<script>
  import Icon from '../components/Icon.svelte'
  import chevronLeftIcon from '../assets/icon/cil-chevron-left.svg'
  import config from '../config.js'
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  function scrollLeft () {
    dispatch('prev')
  }

  function scrollRight () {
    dispatch('next')
  }
</script>

<style type="text/scss">
  .carousel {
    width: 100%;
    position: relative;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;

    .carousel-content {
      height: 100%;
      width: 800px;
      flex-grow: 1;
      flex-shrink: 1;
    }

    .nav {
      width: 50px;
      flex-grow: 1;
      flex-shrink: 1;
      display: flex;
      justify-content: center;
      align-items: center;

      .icon {
        font-size: 32px;
      }

      &.right {
        .icon {
          transform: rotate(180deg);
          transform-origin: center;
        }
      }
    }
  }
</style>

<div class="carousel">
  <button class="nav left" on:click={scrollLeft}>
    <div class="icon">
      <Icon icon={chevronLeftIcon} color="var(--palette-bold-a)" />
    </div>
  </button>
  <div class="carousel-content">
    <slot>CONTENT</slot>
  </div>
  <button class="nav right" on:click={scrollRight}>
    <div class="icon">
      <Icon icon={chevronLeftIcon} color="var(--palette-bold-a)" />
    </div>
  </button>
</div>
